<!--=================================
=            TABLE BASIC            =
==================================-->
<template>
    <!-- data table -->
    <v-container>
        <v-row no-gutters>
            <base-header>
                <div slot="page-header">Tables Basic</div>
            </base-header>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
                <base-card>
                    <div slot="card-header">
                        Playground Table
                        <div class="textt"></div>
                    </div>
                    <div slot="card-body">
                        <div>
                            <table class="table grey--text">
                                <thead>
                                    <tr>
                                        <th scope="col">#</th>
                                        <th scope="col">First</th>
                                        <th scope="col">Last</th>
                                        <th scope="col">Handle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">1</th>
                                        <td>Mark</td>
                                        <td>Otto</td>
                                        <td>@mdo</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">2</th>
                                        <td>Jacob</td>
                                        <td>Thornton</td>
                                        <td>@fat</td>
                                    </tr>
                                    <tr>
                                        <th scope="row">3</th>
                                        <td>Larry</td>
                                        <td>the Bird</td>
                                        <td>@twitter</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
                <base-card>
                    <div slot="card-header">Grouped rows</div>
                    <div slot="card-body">
                        <div>
                            <div class="table-responsive table-responsive-md">
                                <table class="table table-hover grey--text">
                                    <thead>
                                        <tr>
                                            <th>User</th>
                                            <th>Product</th>
                                            <th>Sale</th>
                                            <th>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Jacob</td>
                                            <td>Photoshop</td>
                                            <td class="text-danger">
                                                28.76%
                                                <i class="mdi mdi-arrow-down"></i>
                                            </td>
                                            <td>
                                                <label class="badge badge-danger">Pending</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Messsy</td>
                                            <td>Flash</td>
                                            <td class="text-danger">
                                                21.06%
                                                <i class="mdi mdi-arrow-down"></i>
                                            </td>
                                            <td>
                                                <label class="badge badge-warning">In progress</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>John</td>
                                            <td>Premier</td>
                                            <td class="text-danger">
                                                35.00%
                                                <i class="mdi mdi-arrow-down"></i>
                                            </td>
                                            <td>
                                                <label class="badge badge-info">Fixed</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Peter</td>
                                            <td>After effects</td>
                                            <td class="text-success">
                                                82.00%
                                                <i class="mdi mdi-arrow-up"></i>
                                            </td>
                                            <td>
                                                <label class="badge badge-success">Completed</label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Dave</td>
                                            <td>53275535</td>
                                            <td class="text-success">
                                                98.05%
                                                <i class="mdi mdi-arrow-up"></i>
                                            </td>
                                            <td>
                                                <label class="badge badge-warning">In progress</label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
                <base-card>
                    <div slot="card-header">Search</div>
                    <div slot="card-body">
                        <div>
                            <div class="table-responsive">
                                <table class="table table-bordered grey--text">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>First name</th>
                                            <th>Progress</th>
                                            <th>Amount</th>
                                            <th>Deadline</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Herman Beck</td>
                                            <td>
                                                <div class="progress">
                                                    <div class="progress-bar bg-success" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                            <td>$ 77.99</td>
                                            <td>May 15, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Messsy Adam</td>
                                            <td>
                                                <div class="progress">
                                                    <div class="progress-bar bg-danger" role="progressbar" style="width: 75%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                            <td>$245.30</td>
                                            <td>July 1, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>John Richards</td>
                                            <td>
                                                <div class="progress">
                                                    <div class="progress-bar bg-warning" role="progressbar" style="width: 90%" aria-valuenow="90" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                            <td>$138.00</td>
                                            <td>Apr 12, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>Peter Meggik</td>
                                            <td>
                                                <div class="progress">
                                                    <div class="progress-bar bg-primary" role="progressbar" style="width: 50%" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                            <td>$ 77.99</td>
                                            <td>May 15, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>Edward</td>
                                            <td>
                                                <div class="progress">
                                                    <div class="progress-bar bg-danger" role="progressbar" style="width: 35%" aria-valuenow="35" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                            <td>$ 160.25</td>
                                            <td>May 03, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>John Doe</td>
                                            <td>
                                                <div class="progress">
                                                    <div class="progress-bar bg-info" role="progressbar" style="width: 65%" aria-valuenow="65" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                            <td>$ 123.21</td>
                                            <td>April 05, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>Henry Tom</td>
                                            <td>
                                                <div class="progress">
                                                    <div class="progress-bar bg-warning" role="progressbar" style="width: 20%" aria-valuenow="20" aria-valuemin="0" aria-valuemax="100"></div>
                                                </div>
                                            </td>
                                            <td>$ 150.00</td>
                                            <td>June 16, 2015</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
                <base-card>
                    <div slot="card-header">Remove default header and footer</div>
                    <div slot="card-body">
                        <div>
                            <div class="table-responsive grey--text">
                                <table class="table table-dark">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>First name</th>
                                            <th>Amount</th>
                                            <th>Deadline</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>Herman Beck</td>
                                            <td>$ 77.99</td>
                                            <td>May 15, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>Messsy Adam</td>
                                            <td>$245.30</td>
                                            <td>July 1, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>John Richards</td>
                                            <td>$138.00</td>
                                            <td>Apr 12, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>Peter Meggik</td>
                                            <td>$ 77.99</td>
                                            <td>May 15, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>Edward</td>
                                            <td>$ 160.25</td>
                                            <td>May 03, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>John Doe</td>
                                            <td>$ 123.21</td>
                                            <td>April 05, 2015</td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>Henry Tom</td>
                                            <td>$ 150.00</td>
                                            <td>June 16, 2015</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </base-card>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="12" sm="12" md="12">
                <base-card>
                    <div slot="card-header">Loading state</div>
                    <div slot="card-body">
                        <div>
                            <div class="table-responsive">
                                <table class="table table-bordered grey--text">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>First name</th>
                                            <th>Product</th>
                                            <th>Amount</th>
                                            <th>Deadline</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="table-info">
                                            <td>1</td>
                                            <td>Herman Beck</td>
                                            <td>Photoshop</td>
                                            <td>$ 77.99</td>
                                            <td>May 15, 2015</td>
                                        </tr>
                                        <tr class="table-warning">
                                            <td>2</td>
                                            <td>Messsy Adam</td>
                                            <td>Flash</td>
                                            <td>$245.30</td>
                                            <td>July 1, 2015</td>
                                        </tr>
                                        <tr class="table-danger">
                                            <td>3</td>
                                            <td>John Richards</td>
                                            <td>Premeire</td>
                                            <td>$138.00</td>
                                            <td>Apr 12, 2015</td>
                                        </tr>
                                        <tr class="table-success">
                                            <td>4</td>
                                            <td>Peter Meggik</td>
                                            <td>After effects</td>
                                            <td>$ 77.99</td>
                                            <td>May 15, 2015</td>
                                        </tr>
                                        <tr class="table-primary">
                                            <td>5</td>
                                            <td>Edward</td>
                                            <td>Illustrator</td>
                                            <td>$ 160.25</td>
                                            <td>May 03, 2015</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </base-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
    components: {
        BaseCard,
        BaseHeader
    },
    mounted() {
        $(document).ready(function() {
            $("#example").DataTable();
        });
    },
    data() {
        return {
            singleSelect: false,
            selected: [],
            search: "",
            headers: [{
                    text: "Dessert (100g serving)",
                    align: "left",
                    sortable: false,
                    value: "name"
                },
                {
                    text: "Calories",
                    value: "calories"
                },
                {
                    text: "Fat (g)",
                    value: "fat"
                },
                {
                    text: "Carbs (g)",
                    value: "carbs"
                },
                {
                    text: "Protein (g)",
                    value: "protein"
                },
                {
                    text: "Iron (%)",
                    value: "iron"
                }
            ],
            desserts: [{
                    name: "Frozen Yogurt",
                    calories: 159,
                    fat: 6.0,
                    carbs: 24,
                    protein: 4.0,
                    iron: "1%"
                },
                {
                    name: "Ice cream sandwich",
                    calories: 237,
                    fat: 9.0,
                    carbs: 37,
                    protein: 4.3,
                    iron: "1%"
                },
                {
                    name: "Eclair",
                    calories: 262,
                    fat: 16.0,
                    carbs: 23,
                    protein: 6.0,
                    iron: "7%"
                },
                {
                    name: "Cupcake",
                    calories: 305,
                    fat: 3.7,
                    carbs: 67,
                    protein: 4.3,
                    iron: "8%"
                },
                {
                    name: "Gingerbread",
                    calories: 356,
                    fat: 16.0,
                    carbs: 49,
                    protein: 3.9,
                    iron: "16%"
                },
                {
                    name: "Jelly bean",
                    calories: 375,
                    fat: 0.0,
                    carbs: 94,
                    protein: 0.0,
                    iron: "0%"
                },
                {
                    name: "Lollipop",
                    calories: 392,
                    fat: 0.2,
                    carbs: 98,
                    protein: 0,
                    iron: "2%"
                },
                {
                    name: "Honeycomb",
                    calories: 408,
                    fat: 3.2,
                    carbs: 87,
                    protein: 6.5,
                    iron: "45%"
                },
                {
                    name: "Donut",
                    calories: 452,
                    fat: 25.0,
                    carbs: 51,
                    protein: 4.9,
                    iron: "22%"
                },
                {
                    name: "KitKat",
                    calories: 518,
                    fat: 26.0,
                    carbs: 65,
                    protein: 7,
                    iron: "6%"
                }
            ]
        };
    }
};
</script>
<!--====  End of TABLE BASIC  ====-->